<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('settingsPages.paymentGroups')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div style="display: flex;">
      <div class="card mar-to-15" style="width: 100%; margin-left: 10px; margin-right: 10px;">
        <div class="card-content">
          <div class="text-right">
            <p class="">
              <button class="btn add"  @click.prevent="goToAdd" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
                <img src="/static/img/icons/add.png">
                {{$t('general.add')}}
              </button>
            </p>
          </div>
          <data-tables
                v-loading="loading"
                :data="paymentGroups"
                ref="userList"
                :search-def="{}"
                :pagination-def="{}"
                :table-props="{'border': false}"
                @row-click="goToRecord"
                style="width: 100%">
            <el-table-column v-for="column in tableColumns"
                            :key="column.label"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label"
                            sortable>
            </el-table-column>
            <el-table-column
                  :width="150">
              <template slot-scope="props">
                <div class="edit">
                  <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                </div>
              </template>
            </el-table-column>
          </data-tables>
          <button class="btn btn-info mar-to-15" @click.prevent="showBtPayments = !showBtPayments">{{$t('btPayments.title')}}</button>
          <bt-payment-history v-if="showBtPayments" :company-id="$session.get('selectedCompany')" :key="$session.get('selectedCompany')"></bt-payment-history>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import BtPaymentHistory from './BtPaymentHistory.vue'
  import {Input, Table, TableColumn, Option, Pagination} from 'element-ui'
  import DataTables from 'vue-data-tables'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Option)
  Vue.use(Pagination)
  Vue.use(DataTables)
  export default {
    components: {
      BtPaymentHistory,
      PPagination,
      // GeneralTopBar,
      [Input.name]: Input
    },
    props: {
      callback: {
        required: false
      },
      callbackAdd: {
        required: false
      },
      isTable: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.token = this.$session.get('token')
      this.getData()

      this.$bus.$on('refresh', this.handleRefresh)
    },
    // mounted () {
    //   this.$bus.$on('refresh', this.handleRefresh)
    // },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    data () {
      return {
        loading: true,
        token: null,
        apiUrl: null,
        tableColumns: [
          {
            prop: 'id',
            label: 'ID',
            minWidth: 100
          },
          {
            prop: 'group_name',
            label: this.$t('settingTable.name'),
            minWidth: 300
          },
          {
            prop: 'gateway',
            label: 'Gateway',
            minWidth: 300
          }
        ],
        showBtPayments: false,
        paymentGroups: []
      }
    },
    methods: {
      // goToRecord (row, event, column) {
      //   if (typeof this.callback === 'function') {
      //     this.callback(row.id)
      //     console.log('here1')
      //   } else {
      //     console.log('here')
      //     this.globalGoToRecord(row, event, column, '/user/edit/')
      //   }
      // },
      handleRefresh () {
        this.getData()
      },
      getData () {
        var data = {
          token: this.token,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/payment-group', 'GET', data, (response) => {
          if (response.status === true) {
            this.paymentGroups = response.data

            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      goToAdd () {
        this.$router.push('/payment-groups/add')
      },
      goToRecord (record, event, column) {
        if (!record || !record.id) return

        if (typeof this.callback === 'function') {
          this.callback(record.id)
        } else {
          this.$router.push('/payment-groups/edit/' + record.id)
        }
      }
      // goToAdd () {
      //   if (typeof this.callback === 'function') {
      //     this.callback(null)
      //   }
      // }
    }
  }
</script>
<style>
  .copy_link {
    width: 100%;
  }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/PaymentGroups/PaymentGroups.vue